import {
  ButtonPayloadEnum,
  ProductCarouselComponent as TProductCarouselComponent,
} from "@aichat/types/socket/widget.types";
import { LucideImage } from "lucide-react";
import { Typography } from "../../../typography";
import ButtonComponent from "../buttons/button-component";
type ProductCarouselComponentProps = TProductCarouselComponent;

function ProductCarouselComponent({
  description,
  image,
  title,
  price,
  url,
  currency,
}: ProductCarouselComponentProps) {
  return (
    <div className="flex flex-col w-full h-full gap-4">
      <a
        href={url || undefined}
        target="_blank"
        className="w-full h-full "
        onClick={(e) => {
          if (!url) e.preventDefault();
        }}
      >
        <div className="w-full h-full rounded-2xl border border-secondary shadow-[0px_2px_4px_0px_#00000008,0px_1px_5px_-1px_#0000000F] flex flex-col justify-between">
          <div className="flex-1 p-2">
            {image ? (
              <img
                src={image}
                className="object-cover w-full h-full rounded-lg aspect-video"
              />
            ) : (
              <div className="grid w-full aspect-video place-items-center bg-neutral-200">
                <LucideImage />
              </div>
            )}
          </div>
          <div className="flex flex-col gap-2 p-3">
            <div className="flex flex-col gap-3">
              <div className="flex flex-col gap-1">
                <div className="flex flex-col gap-1">
                  <Typography
                    variant="pMedium"
                    className="text-base font-medium line-clamp-1"
                  >
                    {title}
                  </Typography>
                  {price && (
                    <div className="flex items-center gap-1">
                      <Typography
                        variant="subtle"
                        className="text-muted-foreground"
                      >
                        Price:
                      </Typography>
                      <Typography
                        variant="subtle"
                        className="text-muted-foreground"
                      >
                        {currency} {price}
                      </Typography>
                    </div>
                  )}
                  <Typography
                    variant="detail"
                    className="text-muted-foreground line-clamp-2"
                  >
                    {description}
                  </Typography>
                </div>
              </div>

              {url && (
                <div className="flex flex-col items-start gap-2">
                  <ButtonComponent
                    linkAsButton
                    payload={{
                      type: ButtonPayloadEnum.LINK,
                      value: url,
                    }}
                    className="w-full"
                    variant="carouselPrimary"
                  >
                    View Product
                  </ButtonComponent>
                </div>
              )}
            </div>
          </div>
        </div>
      </a>
      {/* note: hide it for now since AI not giving any response regarding this button */}
      {/* {idx === 0 && (
        <ButtonComponent
          payload={{
            type: ButtonPayloadEnum.LINK,
            value: "https://google.com",
          }}
          variant="quickReply" 
          style={{
            borderColor: brandColorHSLA,
          }}
          onClick={() => {
            if (!handleSendComponent) return;
            handleSendComponent({
              type: ButtonPayloadEnum.LINK,
              value: "https://google.com",
            });
          }}
        >
          Show all products <ArrowRight />
        </ButtonComponent>
      )} */}
    </div>
  );
}

export default ProductCarouselComponent;
